import React from 'react'
import { ButtonWrapper, Calendar, Container, Content, Data, Line, QualificationSection, QualificationSubtitle, QualificationTitle, QualificationWrapper, Rounder, Subtitle, Tabs, Title } from './QualificationStyles'
import { UilGraduationCap, UilBriefcaseAlt,UilCalendarAlt   } from '@iconscout/react-unicons';
import { useState } from 'react';

function Qualification() {
    const [openEdu, setOpenedu] = useState(true);
    const [openWork, setOpenwork] = useState(false);

    const toggleEdu = ()=>{
        if(!openEdu && openWork){
            setOpenwork(!openWork);
            setOpenedu(!openEdu);
        }
    }

    const toggleWork = ()=>{
        if(!openWork && openEdu){
            setOpenedu(!openEdu);
            setOpenwork(!openWork);
        } 
    }

    return (
        <QualificationSection>
            <Title>Qualification</Title>
            <Subtitle>My personal journey</Subtitle>

            <Container>
                <Tabs>
                    <ButtonWrapper open={openEdu} onClick={toggleEdu}>
                        <UilGraduationCap size="1.8rem" className="qualification__icon"/>
                        Education
                    </ButtonWrapper>
                    <ButtonWrapper open={openWork}  onClick={toggleWork}>
                        <UilBriefcaseAlt size="1.8rem"  className="qualification__icon"/>
                        Work
                    </ButtonWrapper>
                </Tabs>

                <QualificationWrapper >
                    {/* ===Qualification content=== */}
                    <Content open={openEdu}>
                        {/* ===Qualification 1=== */}
                        <Data>
                            <div>
                                <QualificationTitle>B.Sc Mathematics/<br/>Computer science</QualificationTitle>
                                <QualificationSubtitle>University of Agriculture, Makurdi</QualificationSubtitle>
                                <br/>
                                <Calendar>
                                    <UilCalendarAlt />
                                    2010 - 2014
                                </Calendar>
                            </div>
                            <div>
                                <Rounder></Rounder>
                                <Line></Line>
                            </div>
                        </Data>

                        {/* ===Qualification 2=== */}
                        <Data>
                            <div></div>

                            <div>
                                <Rounder></Rounder>
                                <Line></Line>
                            </div>

                            <div>
                                <QualificationTitle>Web Design</QualificationTitle>
                                <QualificationSubtitle>Rework Technologies Ltd</QualificationSubtitle>
                                <br/>
                                <Calendar>
                                    <UilCalendarAlt />
                                    2019 - 2020
                                </Calendar>
                            </div>
                            
                        </Data>

                        {/* ===Qualification 3=== */}
                        <Data>
                            <div>
                                <QualificationTitle>Web Development</QualificationTitle>
                                <QualificationSubtitle>Rework Technologies Ltd</QualificationSubtitle>
                                <br/>
                                <Calendar>
                                    <UilCalendarAlt />
                                    2020 - 2021
                                </Calendar>
                            </div>
                            <div>
                                <Rounder></Rounder>
                                {/* <Line></Line> */}
                            </div>
                        </Data>

                    </Content>

                    {/* ===Qualification content 2=== */}
                    <Content open={openWork}>
                        {/* ===Qualification 1=== */}
                        

                        {/* ===Qualification 2=== */}
                        <Data>
                            <div></div>

                            <div>
                                <Rounder></Rounder>
                                <Line></Line>
                            </div>

                            <div>
                                <QualificationTitle>Frontend Developer <br/> (Internship)</QualificationTitle>
                                <QualificationSubtitle>Rework Technologies Ltd</QualificationSubtitle>
                                <br/>
                                <Calendar>
                                    <UilCalendarAlt />
                                    Feb 2021 -  May 2021
                                    
                                </Calendar>
                            </div>
                            
                        </Data>

                        <Data>
                            <div>
                                <QualificationTitle>Backend Developer <br/> (internship)</QualificationTitle>
                                <QualificationSubtitle>Rework Technologies Ltd</QualificationSubtitle>
                                <br/>
                                <Calendar>
                                    <UilCalendarAlt />
                                    May 2021 - Aug 2021
                                </Calendar>
                            </div>
                            <div>
                                <Rounder></Rounder>
                                {/* <Line></Line> */}
                            </div>
                        </Data>

                    </Content>
                </QualificationWrapper>
            </Container>
        </QualificationSection>
    )
}

export default Qualification
